@use '@design/design-tokens/border-radius/border-radius' as *;

.body {
  position: relative;
  width: 100%;
}

.fullscreenButtonContainer {
  display: flex;
  @include border-radius-r2;
  padding: 4px;
  background-color: var(--surface-default);
  height: 40px;
}

.styledChartAreaWrapper {
  height: 240px;
}

.container {
  position: relative;
  width: 100%;

  &.isChatMessage {
    .styledChartAreaWrapper {
      height: 476px;
    }
  }
}
